import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import ResourcesRow from '../features/resources/ResourcesRow';

const resources = [
  {
    id: 1,
    title: '2019 Comprehensive Accreditation Manual for Hospitals (CAMH)',
    subtext: 'Released: December 15, 2018',
    description: 'The official Joint Commission standards and accreditation policies. Everything your hospital needs for continuous compliance. For staff responsible for accreditation, compliance, patient safety, or quality improvement.',
    url: null,
  }, {
    id: 2,
    title: 'ISMP Guidelines for Safe Practice of Adult IV Push Medications, July 2015',
    subtext: 'Released: July 23, 2015',
    description: 'The ISMP Guidelines for Safe Practice of Adult IV Push Medications were developed to help healthcare facilities standardize the safe administration of parenteral IV push medications and prevent unsafe practices and at-risk behaviors associated with IV push administration of adult medications.',
    url: 'https://www.ismp.org/guidelines/iv-push',
  }, {
    id: 3,
    title: 'ASHP Guidelines: Minimum Standard for Pharmacies in Hospitals',
    subtext: (
      <Fragment>
        American Society of Health-System Pharmacists. ASHP guidelines: minimum standard for pharmacies in hospitals.
        {' '}
        <em>Am J Health-Syst Pharm.</em>
        {' '}
        2013; 70:1619–30.
      </Fragment>
    ),
    description: 'These minimum standard guidelines are intended to serve as a basic guide for the provision of pharmacy services in hospitals. These guidelines outline a minimum level of services that most hospital pharmacy departments should consistently provide.',
    url: 'https://www.ashp.org/-/media/assets/policy-guidelines/docs/guidelines/minimum-standard-pharmacies-hospitals.ashx',
  }, {
    id: 4,
    title: 'CDC’s Position — Protect Patients Against Preventable Harm from Improper Use of Single-dose⁄Single-use Vials',
    subtext: '2012; Accessed February 21, 2014',
    description: 'In an effort to ensure clinicians are clear about CDC guidelines, the Agency is restating its position on the use of single-dose/single-use vials and also seeks to dispel inaccuracies being disseminated to healthcare providers.',
    url: 'https://www.cdc.gov/injectionsafety/PDF/CDC-SDV-Position05022012.pdf',
  },
];

function ResourcesPage() {
  return (
    <Fragment>
      <Helmet>
        <title>Reference List</title>
      </Helmet>
      <div className="resources">
        <div className="row">
          <h1 className="resources__heading">
            Reference List
          </h1>
        </div>
        {resources.map(resource => <ResourcesRow key={resource.id} resource={resource} />)}
      </div>
    </Fragment>
  );
}

export default ResourcesPage;



// WEBPACK FOOTER //
// ./src/components/pages/ResourcesPage.js